import React, { useEffect, useState } from 'react';
import { FooterMain } from '../footer/FooterMain';
import { NavLink } from 'react-router-dom';
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';
import { ConfigApp } from "../../controllers/ConfigApp";
import {encode as base64_encode} from 'base-64';

// Start Page Component
export const StartScreen = () => {
    const [imgBackType, setImgBackType] = useState(false);
    const [imgBack, setImgBack] = useState('');
    const [imgLogoType, setImgLogoType] = useState(false);
    const [imgLogo, setImgLogo] = useState('');
    const [imgIconType, setImgIconType] = useState(false);
    const [imgIcon, setImgIcon] = useState('');
    const [colorOne, setColorOne] = useState('');
    const [colorTwo, setColorTwo] = useState('');
    const [colorThree, setColorThree] = useState('');
    const [colorFour, setColorFour] = useState('');
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }
    const hadlePress = (e) => {
        e.currentTarget.classList.remove("btn-wfp-main");
        e.currentTarget.classList.add("btn-wfp-main-press");
    };
    // let img_edu = `${process.env.REACT_APP_PRD_URL}/assets/idEDUF.png`;
    
    let ran = false;
    useEffect(() => {
        if (ran) return;
            if(!window.localStorage.getItem('edufami_background_courses')){
                ConfigApp("/appConfig").then((e)=>{
                    e.forEach(a => {
                        // eslint-disable-next-line default-case
                        switch (a.name_key) {
                            case "edufami_background" :
                                window.localStorage.setItem('edufami_background', JSON.stringify(a));
                                setImgBackType(a.image_type)
                                setImgBack(a.image_value)
                            break;
                            case "edufami_feedback_correct" :
                                window.localStorage.setItem('edufami_feedback_correct', JSON.stringify(a));
                            break;
                            case "edufami_feedback_incorrect" :
                                window.localStorage.setItem('edufami_feedback_incorrect', JSON.stringify(a));
                            break;
                            case "edufami_background_courses" :
                                window.localStorage.setItem('edufami_background_courses', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_logo" :
                                window.localStorage.setItem('edufami_logo', JSON.stringify(a));
                                setImgLogoType(a.image_type)
                                setImgLogo(a.image_value)
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_icon" :
                                window.localStorage.setItem('edufami_icon', JSON.stringify(a));
                                setImgIconType(a.image_type)
                                setImgIcon(a.image_value)
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color1" :
                                window.localStorage.setItem('edufami_color1', JSON.stringify(a));
                                setColorOne(a.text_value)
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color2" :
                                window.localStorage.setItem('edufami_color2', JSON.stringify(a));
                                setColorTwo(a.text_value)
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color3" :
                                window.localStorage.setItem('edufami_color3', JSON.stringify(a));
                                setColorThree(a.text_value)
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color4" :
                                window.localStorage.setItem('edufami_color4', JSON.stringify(a));
                                setColorFour(a.text_value)
                            break;
                        }
                    })
                })
                .catch((e)=>{
                    console.warn(e);
                    document.getElementById('invalidMessage').classList.remove('hide');
                    
                });
            }
            else{
                setImgBackType(JSON.parse(window.localStorage.getItem('edufami_background')).image_type)
                setImgBack(JSON.parse(window.localStorage.getItem('edufami_background')).image_value)

                setImgLogoType(JSON.parse(window.localStorage.getItem('edufami_logo')).image_type)
                setImgLogo(JSON.parse(window.localStorage.getItem('edufami_logo')).image_value)

                setImgIconType(JSON.parse(window.localStorage.getItem('edufami_icon')).image_type)
                setImgIcon(JSON.parse(window.localStorage.getItem('edufami_icon')).image_value)

                setColorOne(JSON.parse(window.localStorage.getItem('edufami_color1')).text_value)

                setColorTwo(JSON.parse(window.localStorage.getItem('edufami_color2')).text_value)

                setColorThree(JSON.parse(window.localStorage.getItem('edufami_color3')).text_value)

                setColorFour(JSON.parse(window.localStorage.getItem('edufami_color4')).text_value)
            }
        return () => (ran = true);
          
    }, [])

    return (
        <div className="fund-start">
            {
                imgBackType && (imgBackType==="svg")
                ?
                <img className="fund-start-b-img" src = {`data:image/svg+xml;base64,${base64_encode(imgBack)}`} alt="Back Ground"/>
                :
                <img className="fund-start-b-img" src = {`data:image/${imgBackType}+xml;base64,${btoa(imgBack)}`} alt="Back Ground"/>
            }
            <div className="fund-start-bl-img">
            {
                imgLogoType && (imgLogoType==="svg")
                ?
                <img className="fund-start-l-img" src = {`data:image/svg+xml;base64,${base64_encode(imgLogo)}`} alt="Back Ground"/>
                :
                <img className="fund-start-l-img" src = {`data:image/${imgLogoType}+xml;base64,${btoa(imgLogo)}`} alt="Back Ground"/>
            }
            </div>

            <div className="text-main">
                <span className="span-txt">
                    {transTxt.start.main.txt_1}
                    <br/>
                    {transTxt.start.main.txt_2}
                    <br/>
                    <br/>
                </span>
                <div className="action-btn">
                <NavLink 
                to="/auth/login" 
                className="btn m-1 btn-block btn-outline-primary btn-wfp-main wfp--link"
                onClick={hadlePress}
                >
                    <button type="button" className="btn-wfp-main" style={{
                        backgroundColor: colorThree,
                        borderColor: colorThree,
                    }}>
                    {transTxt.btn.ing.txt}
                    </button>
                </NavLink>
                </div>
            </div>
            
            <FooterMain />
        </div>
    )
}
